import React, { useState } from "react";
import { object, func } from "prop-types";
import { connect } from "react-redux";

import Button from "../../atoms/Button";
import ProfileHeadline from "../../atoms/ProfileHeadline";
import TextField from "../../atoms/TextField";
import PasswordField from "../../atoms/PasswordField";
import MessageView from "../../atoms/MessageView";

import { verifyEmailOtp } from "../../helper/api";
import { setLoading } from "../../helper/actions";
import { validatePassword } from "../../utils/utils";

import "./change-password.m.css";

const ChangePassword = ({ member, setLoading, navigateToPage }) => {
  const [error, setError] = useState(null);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);

  const onOtpChange = e => {
    // Regex expression to make sure it takes only numbers
    const re = /^[0-9\b]+$/;

    if (!e.target.value || re.test(e.target.value)) {
      setOtp(e.target.value);

      // If error is set remove it since data is changed
      if (otpError) {
        setOtpError(null);
      }
    }
  };

  const onPasswordChange = e => {
    setPassword(e.target.value);

    // If error is set remove it since data is changed
    if (passwordError) {
      setPasswordError(null);
    }
  };

  const validate = () => {
    let flag = false;

    if (!otp) {
      setOtpError("Please provide the OTP provided in your email");
      flag = true;
    }

    const pwdError = validatePassword(password);

    if (pwdError) {
      setPasswordError(pwdError);
      flag = true;
    }

    return flag;
  };

  const onSubmitClick = e => {
    e.preventDefault();

    setError(null);

    if (validate()) {
      // Validations failed
      return;
    }

    setLoading(true);

    verifyEmailOtp(otp, member.id, password)
      .then(() => {
        navigateToPage("/profile");
      })
      .catch(ex => setError("Invalid User/OTP"))
      .finally(() => setLoading(false));
  };

  return (
    <form onSubmit={onSubmitClick}>
      <div styleName="container">
        <ProfileHeadline title="Change Password" arrowClick={() => navigateToPage("/profile")} />

        <div styleName="wrapper">
          <TextField
            value={otp}
            error={otpError}
            label="Enter OTP"
            placeholder="OTP"
            name="otp"
            maxLength="6"
            inputType="type2"
            onChange={onOtpChange}
          />

          <span styleName="message">
            OTP has been send to your email {member.email}. Please enter the same to reset your password.
          </span>

          <PasswordField
            value={password}
            error={passwordError}
            label="New Password *"
            name="new-password"
            onChange={onPasswordChange}
          />

          <span styleName="message">Use 8 or more characters with a mix of letters, number & symbols</span>

          <MessageView type="error" text={error} />

          <Button content="SAVE" buttonType="type4" type="submit" />
        </div>
      </div>
    </form>
  );
};

ChangePassword.propTypes = {
  member: object.isRequired,
  navigateToPage: func.isRequired,
  setLoading: func
};

const mapStateToProps = state => {
  return {
    member: state.member || null
  };
};

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
